// extracted by mini-css-extract-plugin
export default {"item":"TSPx4","image":"DdXD1","text":"_XLby","mappy_picto":"_dAB4"};